import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "~/lib/utils";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Tooltip } from "~/components/Tooltip";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { AssetTableRowData } from "../types";

// // // //

function RedemptionDescription(props: {
    item: AssetTableRowData;
    inline?: boolean;
}) {
    const { item, inline = false } = props;

    // Displays when no value is present
    const empty = (
        <div
            className={cn("flex", {
                "justify-center": !inline,
                "justify-end": inline,
            })}
        >
            <Emdash />
        </div>
    );

    if (item.isAsset) {
        const description = item.primary_market_pegged_asset
            ?.redemption_description
            ? item.primary_market_pegged_asset?.redemption_description
            : "";

        // Return Emdash if no data is present
        if (!description) {
            return empty;
        }

        // Define isRedeemable flag
        const isRedeemable = description !== "Cannot be redeemed.";

        const icon = (
            <FontAwesomeIcon
                icon={isRedeemable ? faCheckCircle : faTimesCircle}
                className={cn("h-4", {
                    "text-blue-400": isRedeemable,
                    "text-muted-foreground": !isRedeemable,
                })}
            />
        );

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="w-max px-3">
                        <p className="py-1.5 text-sm max-w-120">
                            {description}
                        </p>
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <div
                        className={cn("w-full flex cursor-default", {
                            "justify-center": !inline,
                            "items-center gap-1 justify-end": inline,
                        })}
                        ref={setTriggerRef}
                    >
                        {icon}
                        {inline && <>{isRedeemable ? "Yes" : "No"}</>}
                    </div>
                )}
            </Tooltip>
        );
    }

    return empty;
}

// // // //

export const REDEMPTION_DESCRIPTION: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "physical_redemptions",
    label: (
        <>
            Physical
            <br />
            Redemptions
        </>
    ),
    type: ColumnTypes.string,
    width: 130,
    loginRequired: true,
    render: (item) => {
        return <RedemptionDescription item={item} />;
    },
};

// // // //

export const REDEMPTION_DESCRIPTION_INLINE: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    ...REDEMPTION_DESCRIPTION,
    render: (item) => {
        return <RedemptionDescription item={item} inline />;
    },
};
